import { SignalRRequest } from '@adreno-common';
import { RecordSubmitDto } from '@app/work/models';

export class LogPresenceRequest implements SignalRRequest {
  readonly name = 'LogPresence';
  constructor(public payload: LogPresencePayload) {}
}

export interface LogPresencePayload {
  campaignId?: number;
  customData?: string;
  queueId?: number;
  recordId?: number;
  stateId: number;
}

export class SubmitRecordRequest implements SignalRRequest {
  readonly name = 'SubmitRecord';
  constructor(public payload: RecordSubmitDto) {}
}

export class SubmitRecordBase64Request implements SignalRRequest {
  readonly name = 'SubmitRecordBase64';
  constructor(public payload: string) {}
}

export class CloseOtherSessionsRequest implements SignalRRequest {
  readonly name = 'CloseOtherSessions';
  readonly payload = null;
}

export class KillMonitorRequest implements SignalRRequest {
  readonly name = 'KillMonitor';
  constructor(public payload: KillMonitorPayload) {}
}

export interface KillMonitorPayload {
  killMonitor?: boolean;
}
